/**
 * @generated SignedSource<<77f1229126460fe8f8f8a1a87902aad3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentShopify_charge$data = {
  readonly isShopifyCharge: boolean | null | undefined;
  readonly status: string | null | undefined;
  readonly " $fragmentType": "PaymentShopify_charge";
};
export type PaymentShopify_charge$key = {
  readonly " $data"?: PaymentShopify_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentShopify_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentShopify_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isShopifyCharge",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "2444f2b6677e40efe5fda89be3ab38cd";

export default node;
